import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { formatTimeSpan } from "../Common/Utils";

export default function ScoringClock(props) {
  const { seconds, className, onChange, ticking } = props;

  const [pastSeconds, setPastSeconds] = useState(seconds);

  useEffect(() => {
    if (ticking) {
      const tick = setInterval(() => {
        let currentSeconds = pastSeconds;
        currentSeconds += 1;

        if (ticking) {
          setPastSeconds(currentSeconds);
        }

        if (typeof onChange === "function") {
          onChange(currentSeconds);
        }
      }, 1000);

      return () => clearInterval(tick);
    }

    return () => true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticking, seconds]);

  return <span className={className}>{formatTimeSpan(pastSeconds, true)}</span>;
}

ScoringClock.propTypes = {
  seconds: PropTypes.number,
  className: PropTypes.string,
  ticking: PropTypes.bool,
  onChange: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
};

ScoringClock.defaultProps = {
  seconds: 0,
  ticking: false,
  onChange: false,
};
